import colorsVars from 'styles/colors.module.scss';

export const { todoCardBackground, doneCardBackground, inProgressCardBackground, notFoundBackground } = colorsVars;

export type Status = 'TODO' | 'DONE' | 'IN_PROGRESS' | 'NOT_STARTED' | 'COMPLETED';
export const getStatusColorHex = (status: Status): string => {
    switch (status) {
        case 'TODO':
            return todoCardBackground;
        case 'DONE':
            return doneCardBackground;
        case 'IN_PROGRESS':
            return inProgressCardBackground;
        case 'NOT_STARTED':
            return todoCardBackground;
        case 'COMPLETED':
            return doneCardBackground;
        default:
            return notFoundBackground;
    }
};
export const getStatusLabel = (param: Status | undefined) => {
    switch (param) {
        case 'TODO':
            return 'To Do';
        case 'DONE':
            return 'Done';
        case 'IN_PROGRESS':
            return 'In Progress';
        case 'NOT_STARTED':
            return 'To Do';
        case 'COMPLETED':
            return 'Done';
        default:
            return 'No Change';
    }
};
type StatusColor = 'TODO' | 'To Do' | 'DONE' | 'Done' | 'IN_PROGRESS' | 'In Progress' | 'NOT_STARTED' | 'COMPLETED';
export const getStatusColor = (param: StatusColor | undefined) => {
    switch (param) {
        case 'TODO':
        case 'To Do':
            return 'toDo';
        case 'DONE':
        case 'Done':
            return 'done';
        case 'IN_PROGRESS':
        case 'In Progress':
            return 'inProgress';
        case 'NOT_STARTED':
            return 'notStarted';
        case 'COMPLETED':
            return 'completed';
        default:
            return 'notFound';
    }
};
export const getStatusColorHexByLaneId = (laneId: string): string => {
    switch (laneId) {
        case '1':
            return todoCardBackground;
        case '2':
            return inProgressCardBackground;
        case '3':
            return doneCardBackground;
        default:
            return todoCardBackground;
    }
};
